export default __webpack_public_path__ + "e54c39cbf337fa66940c513690b9ba87.webmanifest";